module.exports = __webpack_public_path__ + "img/full1-min.5661e6d4.png";